var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderCheckoutBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.00001H13.3333C13.3333 3.15834 11.8416 1.66667 9.99992 1.66667C8.15825 1.66667 6.66659 3.15834 6.66659 5.00001H4.99992C4.08325 5.00001 3.33325 5.75001 3.33325 6.66667V16.6667C3.33325 17.5833 4.08325 18.3333 4.99992 18.3333H14.9999C15.9166 18.3333 16.6666 17.5833 16.6666 16.6667V6.66667C16.6666 5.75001 15.9166 5.00001 14.9999 5.00001ZM9.99992 3.33334C10.9166 3.33334 11.6666 4.08334 11.6666 5.00001H8.33325C8.33325 4.08334 9.08325 3.33334 9.99992 3.33334ZM14.9999 16.6667H4.99992V6.66667H6.66659V8.33334C6.66659 8.79167 7.04159 9.16667 7.49992 9.16667C7.95825 9.16667 8.33325 8.79167 8.33325 8.33334V6.66667H11.6666V8.33334C11.6666 8.79167 12.0416 9.16667 12.4999 9.16667C12.9583 9.16667 13.3333 8.79167 13.3333 8.33334V6.66667H14.9999V16.6667Z",
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCheckoutBag);
export default __webpack_public_path__ + "static/media/headerCheckoutBag.1a3012d85b19a3164fef3b04c394a68d.svg";
export { ForwardRef as ReactComponent };